import Alpine from 'alpinejs';
import Swiper from 'swiper/bundle';

window.Alpine = Alpine;
window.Swiper = Swiper;

import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import anchor from '@alpinejs/anchor';
import intersect from '@alpinejs/intersect';

import './js/product';
import './js/cart';

import AOS from 'aos';

AOS.init({
  once: true,
});

document.addEventListener('DOMContentLoaded', function () {
  AOS.refresh();
});

let scrollRef = 0;

window.addEventListener('scroll', function () {
  // increase value up to 10, then refresh AOS
  scrollRef++;
  if (scrollRef >= 10) {
    AOS.refresh();
    scrollRef = 0;
  }
});

Alpine.data('collections_swiper', (spaceBetweenSlides) => ({
  init() {
    new Swiper('.swiper-container-collections', {
      direction: 'horizontal',
      initialSlide: 0,
      loop: false,
      slidesPerView: 2,
      spaceBetween: spaceBetweenSlides,
      /* scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      }, */
      pagination: {
        el: '.swiper-pagination-collection',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 5,
        },
      },
    });
  },
}));

Alpine.data('hotspot_swiper', () => ({
  init() {
    new Swiper('.swiper-container-hotspot', {
      direction: 'horizontal',
      initialSlide: 0,
      loop: true,
      slidesPerView: 1.1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-hotspot-next',
        prevEl: '.swiper-hotspot-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  },
}));

Alpine.data('collections_swiper_alt', (spaceBetweenSlides) => ({
  isLoading: true,
  spaceBetween: spaceBetweenSlides,
  init() {
    console.log('init', spaceBetweenSlides);
    new Swiper('.swiper-container', {
      direction: 'horizontal',
      initialSlide: 0,
      loop: false,
      slidesPerView: 1.5,
      spaceBetween: this.spaceBetween,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
    });
    this.isLoading = false;
  },
}));

// Featured Collection Switcher Slider Swiper
Alpine.data('feat_collection_slider', () => ({
  init() {
    new Swiper('.swiper_feat_collection_slider_1', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 2,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        0: {
          slidesPerGroup: 4,
          grid: { rows: 2, fill: 'row' },
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });

    new Swiper('.swiper_feat_collection_slider_2', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 2,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        0: {
          slidesPerGroup: 4,
          grid: { rows: 2, fill: 'row' },
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
    new Swiper('.swiper_feat_collection_slider_3', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 2,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        0: {
          slidesPerGroup: 4,
          grid: { rows: 2, fill: 'row' },
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  },
}));

// Gender Selector Component
Alpine.data('genderSelector', () => ({
  gender: 'A',

  init() {
    // Get gender from session storage or default to 'A'
    this.gender = sessionStorage.getItem('gender_selector') || 'A';
  },

  setGender(value) {
    this.gender = value;
    sessionStorage.setItem('gender_selector', value);
  },
}));

// Hero Slideshow Swiper
Alpine.data('hero_slideshow', () => ({
  init() {
    const container = this.$el;
    const autoplayEnabled = container.dataset.autoplayEnabled === 'true';
    const autoplayDelay = parseInt(container.dataset.autoplayDelay) || 5000;
    const pauseOnHover = container.dataset.pauseOnHover === 'true';

    const swiperConfig = {
      direction: 'horizontal',
      initialSlide: 0,
      loop: true,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    };

    // Add autoplay configuration if enabled
    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover,
      };
    }

    new Swiper('.swiper-slideshow', swiperConfig);
  },
}));

Alpine.data('hoverVideo', () => ({
  video: null,
  observer: null,
  currentlyPlaying: null,
  init() {
    this.playVideo();
    window.addEventListener('resize', () => {
      this.playVideo();
    });
  },
  playVideo() {
    this.video = this.$el;
    if (window.innerWidth < 768) {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.currentlyPlaying && this.currentlyPlaying !== this.video) {
                this.currentlyPlaying.pause();
              }
              this.video.play();
              this.currentlyPlaying = this.video;
            } else {
              this.video.pause();
              if (this.currentlyPlaying === this.video) {
                this.currentlyPlaying = null;
              }
            }
          });
        },
        { threshold: 0.5 }
      );
      this.observer.observe(this.video);
      return;
    }

    this.video.autoplay = false;
    this.video.currentTime = 1;
    if (this.video.classList.contains('banner-video')) {
      this.video.play();
    }

    const sliderContainer = this.$el.closest('.swiper-slide');
    sliderContainer.addEventListener('mouseover', ($event) => {
      this.video.play();
    });

    sliderContainer.addEventListener('mouseout', ($event) => {
      this.video.pause();
    });
  },
}));

Alpine.data('scalableSection', () => ({
  init() {
    const section = this.$el;
    const scaleStartThreshold = 60;
    const minScale = 0.6;
    const maxScale = 1;

    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;
      const scrolledPercentage = (Math.max(0, scrollY - sectionTop) * 100) / sectionHeight;
      if (scrolledPercentage >= 100) {
        section.style.transform = `scale(${minScale})`;
        return;
      }

      if (scrolledPercentage < scaleStartThreshold) {
        section.style.transform = `scale(${maxScale})`;
        return;
      }

      const difference = scrolledPercentage - scaleStartThreshold;
      const scale = minScale + (maxScale - minScale) * (1 - difference / (100 - scaleStartThreshold));
      section.style.transform = `scale(${scale})`;
    });
  },
}));

Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(anchor);
Alpine.plugin(intersect);
Alpine.start();
